const state = {
  authority: [],
  componentId: '',
};

const mutations = {
  setPower (state, payload) {
    state.authority = payload
  },
  setComponentId (state, payload) {
    state.componentId = payload
  },
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
